import React from "react";
import Filters from "../../components/faceswap/filters";

export default function Filter() {
  return <Filters />;
}
